import style from "modules/SelectionOfPsychologists/components/Card/PublicServicePrice/price.module.scss"
import { OfferedService, Psychologist } from "utils/interfaces"
import { Price } from "components"

interface Props {
    psy: Psychologist
    service: OfferedService
}

export const PublicServicePrice = ({ psy, service }: Props) => {
    return (
        <div className={style.servicePrice} key={service.name}>
            {service.name}&nbsp;—&nbsp;
            <Price psy={psy} singleServicePrice={service.price} />
        </div>
    )
}
